import { AnatomicalSystemModel } from "./anatomicalSystemModel";
import { FrequencyOfReactionModel } from "./frequencyOfReactionModel";
import { IngredientSideEffectReactionContentModel } from './ingredientSideEffectReactionContentModel';

export class IngredientSideEffectReactionModel {
  public ingredientSideEffectReactionId: number;
  public frequencyOfReaction: FrequencyOfReactionModel;
  public anatomicalSystemId: number;
  public anatomicalSystem: AnatomicalSystemModel;
  public ingredientSideEffectReactionContent: Array<IngredientSideEffectReactionContentModel>;
}